<template>
  <div>
    <div class="mt-5 d-flex justify-space-between heading-1">Order Detail</div>
    <v-row class="mt-3">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1"> Order No:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2"
            >#{{ orderDetails && orderDetails?.OrderCode }}
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Email Address:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2">
            {{ getUserPurchaseAndBillings?.UserEmail }}
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Placed Date:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2">{{
            formatDate(orderDetails?.Items[0]?.OrderDate)
          }}</span>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Received Date:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2">{{
            formatDate(orderDetails?.Items[0]?.Shipping?.ReceivedDate)
          }}</span>
        </div>
      </v-col>
    </v-row>
    <!-- <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1"> Product Service Name:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <router-link to="" class="mt-2 text-decoration-underline"
            >Seminar Payement for Finding Health consolidated- LIVESTREAM in FL
            starting 04 March
          </router-link>
        </div>
      </v-col>
    </v-row> -->
    <!-- <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Course Status: </span>
      </v-col>
      <v-col cols="12" md="9">
        <span class="style_txt_hh2"
          >Finding Health consolidated- LIVESTREAM
        </span>
      </v-col>
    </v-row> -->
    <v-row class="mt-0" v-if="orderDetails?.Items[0]?.Product?.CategoryId !== 26">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Status:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2">
            <v-card max-width="150" flat>
              <v-select
                class="my-0 py-0"
                v-model="selectedStatus"
                :items="orderStatusItems"
                item-value="Status"
                item-text="state"
                label="Select"
                persistent-hint
                return-object
                single-line
                @change="setNewOrderStatus"
              >
              </v-select> </v-card
          ></span>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0" v-if="orderDetails?.Items[0]?.Product?.CategoryId !== 26">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Ship Date:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2">{{
            formatDate(orderDetails?.Items[0]?.Shipping?.ShippedDate)
          }}</span>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0" v-if="orderDetails?.Items[0]?.Product?.CategoryId !== 26">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Ship Method:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2">{{
            orderDetails && orderDetails?.Items[0]?.Shipping?.ShippingMethod
          }}</span>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0" v-if="orderDetails?.Items[0]?.Product?.CategoryId !== 26">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Notes:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2">
            {{ orderDetails && orderDetails?.Items[0]?.Shipping?.ShippingNote }}
            <!-- <v-edit-dialog :return-value.sync="notes">
              {{ notes }}
              <template v-slot:input>
                <v-text-field
                  v-model="notes"
                  label="Edit"
                  single-line
                  counter
                />
              </template>
              <v-btn
                color="primary"
                depressed
                class="text_trans ml-14"
                outlined
                rounded
                >Update
              </v-btn>
            </v-edit-dialog> -->
          </span>
        </div>
      </v-col>
    </v-row>

    <v-row class="my-5" v-if="orderDetails?.Items[0]?.Product?.CategoryId !== 26">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Billing Address:</span>
        <div class="mt-3">
          <span class="style_txt_hh2">
            {{ orderDetails && orderDetails?.Items[0]?.Billing?.FirstName }}
            {{ orderDetails && orderDetails?.Items[0]?.Billing?.LastName }}
            <br />
            {{
              orderDetails && orderDetails?.Items[0]?.Billing?.StreetAddress1
            }}
            {{
              orderDetails && orderDetails?.Items[0]?.Billing?.StreetAddress2
            }}
            <br />
            {{ orderDetails && orderDetails?.Items[0]?.Billing?.City }}
            {{ orderDetails && orderDetails?.Items[0]?.Billing?.ZipCode }}
            {{ orderDetails && orderDetails?.Items[0]?.Billing?.Province }}
            <br />
            {{ orderDetails && orderDetails?.Items[0]?.Billing?.Country }}</span
          >
        </div>
      </v-col>
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Shipping Address :</span>
        <div class="mt-3">
          <span class="style_txt_hh2">
            {{ orderDetails && orderDetails?.Items[0]?.Shipping?.FirstName }}
            {{ orderDetails && orderDetails?.Items[0]?.Shipping?.LastName }}
            <br />
            {{
              orderDetails && orderDetails?.Items[0]?.Shipping?.StreetAddress1
            }}
            {{
              orderDetails && orderDetails?.Items[0]?.Shipping?.StreetAddress2
            }}
            <br />
            {{ orderDetails && orderDetails?.Items[0]?.Shipping?.City }}
            {{ orderDetails && orderDetails?.Items[0]?.Shipping?.ZipCode }}
            {{ orderDetails && orderDetails?.Items[0]?.Shipping?.Province }}
            <br />
            {{
              orderDetails && orderDetails?.Items[0]?.Shipping?.Country
            }}</span
          >
        </div>
      </v-col>
    </v-row>

    <div><span class="style_txt_hh2 primary--text">Product Details </span></div>
    <div class="my-5">
      <v-row>
        <v-col cols="12" md="9">
          <table style="width: 100%; border-collapse: collapse">
            <tr style="border: 1px solid">
              <th style="border: 1px solid; width: 25%">
                <div class="d-flex justify-center py-2">Product Type</div>
              </th>
              <th style="border: 1px solid; width: 30%">
                <div class="d-flex justify-center py-2">Name</div>
              </th>
              <th style="border: 1px solid; width: 13%">
                <div class="d-flex justify-center py-2 text-center">Unit Price</div>
              </th>
              <th style="border: 1px solid; width: 12%">
                <div class="d-flex justify-center py-2">Quantity</div>
              </th>
              <th style="border: 1px solid; width: 20%">
                <div class="d-flex justify-center py-2">Subtotal</div>
              </th>
            </tr>
            <tr
              v-for="(item, index) in orderDetails && orderDetails?.Items"
              :key="index"
              style="border: 1px solid"
            >
              <td style="border: 1px solid; width: 25%">
                <div class="d-flex justify-center pa-2">{{ getProductCategoryLabel(item?.Product?.CategoryId) }}</div>
              </td>
              <td style="border: 1px solid; width: 30%">
                <div class="d-flex justify-center pa-2">
                  {{ item?.Product?.ProductName }}
                </div>
              </td>
              <td style="border: 1px solid; width: 13%">
                <div class="d-flex justify-center pa-2">
                  <span v-if="orderDetails?.Items[0]?.Product?.CategoryId === 26">
                    {{ (orderDetails?.Items[0]?.Payment?.Price / item?.Quantity)?.toFixed(2) }}
                  </span><span v-else>
                    {{ item?.Product?.PublicPrice }}
                  </span>
                </div>
              </td>
              <td style="border: 1px solid; width: 12%">
                <div class="d-flex justify-center pa-2">
                  {{ item?.Quantity }}
                </div>
              </td>
              <td style="border: 1px solid; width: 20%">
                <div class="d-flex justify-center pa-2">
                  <span v-if="orderDetails?.Items[0]?.Product?.CategoryId === 26">
                    {{ orderDetails?.Items[0]?.Payment?.Price?.toFixed(2) }}
                  </span>
                  <span v-else>
                    {{ (item?.Product?.PublicPrice * item?.Quantity)?.toFixed(2) }}
                  </span>
                  <!-- *
                      (1 - item.Product.DiscountPercentage / 100) -->
                </div>
              </td>
            </tr>
          </table>
          <div style="width: 100%" class="d-flex align-center">
            <div style="width: 80.2%; border: 1px solid; border-top: none">
              <div class="pa-2 px-4"><b>Product Total</b></div>
            </div>
            <div
              style="
                width: 20%;
                border: 1px solid;
                border-top: none;
                border-left: none;
              "
            >
              <div class="d-flex justify-center pa-2">
                $
                <span v-if="orderDetails?.Items[0]?.Product?.CategoryId === 26">
                  {{ orderDetails?.Items[0]?.Payment?.Price?.toFixed(2) }}
                </span><span v-else>
                  {{
                    calculateTotalDiscount(orderDetails && orderDetails?.Items)
                      .totalAmount
                  }}
                </span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-divider></v-divider>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Payment Method:</span>
      </v-col>

      <v-col cols="12" md="9">
        <div>
          <div class="d-flex algin-center">
            <div v-if="orderDetails?.Items[0]?.PaymentType == 1">
              <VisaSvgIcon class="mr-3"></VisaSvgIcon>
              <div class="d-flex align-center">
                <!-- <div class="mt-2">****</div> -->
                <div>
                  {{
                    orderDetails?.Items[0]?.Payment?.CardNumber &&
                    "**** " +
                      orderDetails?.Items[0]?.Payment?.CardNumber?.slice(-4)
                  }}
                </div>
              </div>
            </div>
            <span v-else-if="orderDetails?.Items[0]?.PaymentType == 2">Paypal</span>
            <span v-else>Admin</span>
          </div>
          <!---------------------if payemnt on Paypal ------------------------------------>
          <!-- <span> Paypal</span> -->
        </div>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Product Total:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2"
            >$ <span v-if="orderDetails?.Items[0]?.Product?.CategoryId === 26">
              {{ orderDetails?.Items[0]?.Payment?.Price?.toFixed(2) }}
            </span><span v-else>
              {{
                calculateTotalDiscount(orderDetails && orderDetails?.Items)
                  .totalAmount
              }}
            </span>
          </span>
        </div>
      </v-col>
    </v-row>
    <!-- <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">User Credits</span>
      </v-col>
      <v-col cols="12" md="9">
        <div><span class="style_txt_hh2">($25.00)</span></div>
      </v-col>
    </v-row> -->
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Product Discount</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2"
            >$
            {{
              calculateTotalDiscount(orderDetails && orderDetails?.Items)
                .totalDiscountApplied
            }}</span
          >
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Coupon Discount</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2"
            >$
            {{
              calculateTotalDiscount(orderDetails && orderDetails?.Items)
                .couponDiscount
            }}</span
          >
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Total Discount</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2"
            >$ {{ totalDiscountvalue }}
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Subtotal:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2"
            >$ <span v-if="orderDetails?.Items[0]?.Product?.CategoryId === 26">
              {{ orderDetails?.Items[0]?.Payment?.Price?.toFixed(2) }}
            </span><span v-else>
              {{ 
                (calculateTotalDiscount(orderDetails && orderDetails?.Items)
              .totalAmountWithDiscount - calculateTotalDiscount(orderDetails && orderDetails?.Items)
              .couponDiscount)?.toFixed(2) 
              }}
            </span>
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Tax:</span>
      </v-col>
      <v-col cols="12" md="9">
        <div><span class="style_txt_hh2">$ {{ calculateTax?.toFixed(2) }}</span></div>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1">Shipping </span>
      </v-col>
      <v-col cols="12" md="9">
        <div><span class="style_txt_hh2">$ {{ (shippingPrice)?.toFixed(2) }}</span></div>
      </v-col>
    </v-row>
    <v-row class="mt-0 mb-16">
      <v-col cols="12" md="3">
        <span class="style_txt_hh1"><b>Total:</b></span>
      </v-col>
      <v-col cols="12" md="9">
        <div>
          <span class="style_txt_hh2"
            ><b>$ <span v-if="orderDetails?.Items[0]?.Product?.CategoryId === 26">
              {{ orderDetails?.Items[0]?.Payment?.Price?.toFixed(2) }}
            </span><span v-else>
            {{
              (Number(calculateTotalDiscount(orderDetails && orderDetails?.Items)
                .totalAmountWithDiscount) + shippingPrice + calculateTax - calculateTotalDiscount(orderDetails && orderDetails?.Items)
                .couponDiscount)?.toFixed(2)
            }}
          </span></b></span
          >
        </div>
      </v-col>
    </v-row>
    <!-- <v-row class="mt-0">
      <v-col cols="12" md="3">
        <span><b></b></span>
      </v-col>
      <v-col cols="12" md="9">
       
    <div class="mt-10">
    <v-btn depressed color="primary">
        Update
    </v-btn>
    </div>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VisaSvgIcon from "../../assets/SvgIcons/VisaSvgIcon.vue";
export default {
  name: "my-component",
  props: {
    shipmethod: {
      type: String,
      default: "cash on delivery",
    },
    notes: {
      type: String,
      default:
        "Seminar Payement for Finding Health consolidated Seminar Payment for Finding Health consolidated Seminar Payment for Finding Health consolidated",
    },
  },
  components: { VisaSvgIcon },
  data() {
    return {
      isRecieveOrShipDate: false,
      time: "5:54 a.m",
      select: { state: "VOID" },
      orderStatusItems: [
        { state: "NEW", Status: 2 },
        { state: "RECEIVED", Status: 3 },
        { state: "SHIPPED", Status: 4 },
        { state: "INVOICED", Status: 5 },
        { state: "VOID", Status: 6 },
      ],
      selectedStatus: 2,
      orderDetails: null,
    };
  },
  computed: {
    ...mapGetters([
      "GetPreviewUser",
      "GetUserOrders",
      "getUserPurchaseAndBillings",
      "GetProductCategories"
    ]),
    getProductCategoryLabel() {
      return (categoryId) => {
        const category = this.GetProductCategories.find(
          (item) => item.Category.Id === categoryId
        );
        return category ? category.Category.CategoryName : "";
      };
    },
    orderDetailsStatus() {
      return this.orderDetails && this.orderDetails?.Items[0]?.InvoiceStatus;
    },
    shippingPrice() {
      let str = this.orderDetails?.Items[0]?.Shipping?.ShippingMethod;
      let match = str?.match(/\(([^)]+)\)/);
      if (match) {
        let number = parseFloat(match[1]);
        return number;
      }
      return 0;
    },
    totalDiscountvalue() {
      const discountApplied = parseFloat(this.calculateTotalDiscount(this.orderDetails && this.orderDetails?.Items).totalDiscountApplied) || 0;
      const couponDiscount = parseFloat(this.calculateTotalDiscount(this.orderDetails && this.orderDetails?.Items).couponDiscount) || 0;

      const totaldiscountvalue = discountApplied + couponDiscount;
      return totaldiscountvalue?.toFixed(2); // If you want to return it as a string with 2 decimal places
    },
    calculateTax() {
      if (
        this.orderDetails &&
        this.orderDetails?.Items[0]?.Shipping?.Country?.toLowerCase() === "united states" &&
        this.orderDetails?.Items[0]?.Shipping?.Province?.toLowerCase() === "fl"
      ) {
        const totalAmountWithDiscount = this.calculateTotalDiscount(this.orderDetails?.Items).totalAmountWithDiscount;

        const hasPhysicalProduct = this.orderDetails?.Items?.some((item) => item?.Product?.IsPhysical);

        if (hasPhysicalProduct) {
          return totalAmountWithDiscount * 0.07;
        }
      }
      return 0;
    },
  },
  watch: {
    orderDetailsStatus: {
      immediate: true,
      handler(newValue) {
        if (
          Array.isArray(this.orderStatusItems) &&
          this.orderStatusItems.length > 0
        ) {
          this.selectedStatus = newValue;
        }
      },
    },
  },

  mounted() {
    this.fetchData(this.isRecieveOrShipDate);
    if(this.GetProductCategories.length == 0){
      this.$store.dispatch("GetProductCategories");
    }
  },
  methods: {
    fetchData(istrue) {
      const userId =
        (this.GetPreviewUser && this.GetPreviewUser?.Id) ||
        this.$route.query.userId;

      this.orderDetails = this.getUserPurchaseAndBillings?.store?.find(
        (order) => order.OrderCode === this.$route.query.ordernumber
      );
      if (!this.orderDetails || istrue) {
        this.$store
          .dispatch("GetUserPurchaseAndBillings", { id: userId })
          .then(() => {})
          .catch((error) => {
            console.error("Error fetching orders:", error);
          })
          .finally(() => {
            this.orderDetails = this.getUserPurchaseAndBillings.store.find(
              (order) => order.OrderCode === this.$route.query.ordernumber
            );

            if (!this.orderDetails) {
              this.$swal.fire({
                toast: true,
                position: "top-end",
                icon: "error",
                title: "No Data Found",
                showConfirmButton: false,
                timer: 3500,
              });
            }
          });
      }
    },
    formatDate(dateString) {
      if (!dateString) {
        return;
      }

      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      };

      const date = new Date(dateString);
      return date.toLocaleString("en-US", options);
    },
    async setNewOrderStatus() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      let hours = String(currentDate.getHours()).padStart(2, "0");
      const minutes = String(currentDate.getMinutes()).padStart(2, "0");
      const seconds = String(currentDate.getSeconds()).padStart(2, "0");
      const formattedDateTime = `${formattedDate}T${hours}:${minutes}:${seconds}`;

      const selectedStatusObject = this.selectedStatus;
      const selectedStatusValue = selectedStatusObject
        ? selectedStatusObject.Status
        : null;

      var obj = {
        orderCode: this.$route.query.ordernumber,
        status: selectedStatusValue,
      };

      var data = {
        id: this.orderDetails?.Items[0]?.Shipping?.Id,
        status: selectedStatusValue,
        dateTime: formattedDateTime,
      };
      if (selectedStatusValue == 3 || selectedStatusValue == 4) {
        if(!this.orderDetails?.Items[0]?.Shipping?.Id) {
          await this.$swal.fire({
              toast: true,
              position: "top-end",
              icon: "info",
              title: `The ${selectedStatusValue == 3 ? 'recieved' : 'shipped'} date will not be showing because shipping id is not found`,
              showConfirmButton: false,
              timer: 3000,
            });
          }}
      await this.$store
        .dispatch("ChangeOrderStatus", obj)
        .then((res) => {
          if (res.Status) {
            this.$swal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: "Status changed successfully",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        })
        .catch((error) => {
          console.error("Error changing order status:", error);
          // this.$store.dispatch("GetAllOrder");
        });
      if (selectedStatusValue == 3 || selectedStatusValue == 4) {
        if(!this.orderDetails?.Items[0]?.Shipping?.Id) {
            return;
          }
        this.$store
          .dispatch("UpdateOrderShipAndReceivedDate", data)
          .then(() => {
            this.fetchData(true);
          });
      }
    },
    calculateTotalDiscount(items) {
      if (Array.isArray(items) && items.length > 0) {
        // Calculate the total discounted amount and total amount for all items
        const { totalDiscount, totalAmount } = items.reduce(
          (acc, item) => {
            // Inside the reduce function, calculate the total and discounted amount for each item
            const { discountedAmount, amount } =
              this.calculateAmountAndDiscount(item);

            // Add the discounted amount to the total discount
            acc.totalDiscount += parseFloat(discountedAmount);
            // Add the total amount to the total amount
            acc.totalAmount += parseFloat(amount);

            return acc;
          },
          { totalDiscount: 0, totalAmount: 0 }
        );

        // Calculate the total discount applied to the total amount
        const totalDiscountApplied = totalAmount - totalDiscount;
        const couponDiscount = this.orderDetails?.Items[0]?.CouponDetail?.DiscountValue
          ? totalAmount * (parseFloat(this.orderDetails?.Items[0]?.CouponDetail?.DiscountValue) / 100)
          : 0;

        // Return an object containing the required values
        return {
          totalAmount: totalAmount?.toFixed(2),
          couponDiscount: couponDiscount?.toFixed(2),
          totalDiscountApplied: totalDiscountApplied?.toFixed(2),
          totalAmountWithDiscount: totalDiscount?.toFixed(2),
        };
      } else {
        // Return an object with default values if the array is empty or invalid
        return {
          totalAmount: 0.00,
          totalDiscountApplied: 0.00,
          totalAmountWithDiscount: 0.00,
          couponDiscount: 0.00,
        };
      }
    },

    calculateAmountAndDiscount(item) {
      // Calculate the discounted amount for a single item
      const discountedAmount = (
        (1 - item.Product.DiscountPercentage / 100) * // Discount factor
        item.Product.PublicPrice *
        item.Quantity
      )?.toFixed(2);

      // Calculate the total amount for a single item
      const amount = (item.Product.PublicPrice * item.Quantity)?.toFixed(2);

      // Return an object containing both the total amount and discounted amount
      return { amount, discountedAmount };
    },
  },
};
</script>

<style scoped>
.sub-heading {
  font-size: 20px;
}
.style_txt_hh1 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;

  color: rgba(34, 34, 34, 0.7);
}
.style_txt_hh2 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;

  color: #222222;
}
.stying_text {
  text-transform: none !important;
  border: 1px solid #d2e5fc;
  font-size: 14px;
  font-family: "DM Sans";
}
.text_trans {
  text-transform: none;
}
</style>
